import { useQuery } from "urql"

import type {
  GetLocationDeliveryPackagingPreferenceQuery,
  LocationDeliveryPackagingPreference,
} from "@/graphql/codegen/graphql"
import { GetLocationDeliveryPackagingPreferenceDocument } from "@/graphql/codegen/graphql"

interface UseGetDeliveryPackagingResult {
  data: LocationDeliveryPackagingPreference | null
  isFetching: boolean
  refetch: () => void
}

export const useGetDeliveryPackaging = (locationId: string): UseGetDeliveryPackagingResult => {
  const [result, refetch] = useQuery<GetLocationDeliveryPackagingPreferenceQuery>({
    query: GetLocationDeliveryPackagingPreferenceDocument,
    variables: {
      shipToLocationId: locationId,
    },
  })

  const data =
    result.data?.locationDeliveryPackagingPreference.get.__typename === "LocationDeliveryPackagingPreferenceGetSuccess"
      ? (result.data.locationDeliveryPackagingPreference.get.preference ?? null)
      : null

  return {
    data,
    isFetching: result.fetching,
    refetch: () => {
      refetch({ requestPolicy: "network-only" })
    },
  }
}
